module.exports = __webpack_public_path__ + "media/images/front/programs/icon-book-active-b556449007bde80f95fc24e43c20bafd.svg";